// Suggestions for a search field: the distinct values, most frequent first.

/** Distinct values, most frequent first, ties in first-seen order; blanks left out. */
export function byFrequency(values: ReadonlyArray<string | undefined>): string[] {
  const counts = new Map<string, number>();
  for (const v of values) if (v && v.trim()) counts.set(v, (counts.get(v) ?? 0) + 1);
  return [...counts.entries()].sort((a, b) => b[1] - a[1]).map(([v]) => v);
}
